export type RequestOptions = {
  method?: 'GET' | 'POST' | 'PATCH' | 'PUT' | 'DELETE'
  data?: Record<string, unknown> | FormData
}

function csrfToken(): string | null {
  const token = document.querySelector('meta[name="csrf-token"]')
  return token ? token.getAttribute('content') : null
}

export async function requestJson<T = Record<string, unknown>>(url: string, options: RequestOptions = {}): Promise<T | null> {
  const method = options.method || 'GET'
  const headers: HeadersInit = {
    Accept: 'application/json',
  }

  const token = csrfToken()
  if (token) headers['X-CSRF-Token'] = token

  let body: BodyInit | undefined

  if (options.data instanceof FormData) {
    body = options.data
  } else if (options.data) {
    headers['Content-Type'] = 'application/json'
    body = JSON.stringify(options.data)
  }

  const response = await fetch(url, {
    method,
    headers,
    body,
    credentials: 'same-origin',
  })

  if (response.status === 204) return null

  const contentType = response.headers.get('content-type') || ''
  const payload = contentType.includes('application/json') ? await response.json() : await response.text()

  if (!response.ok) {
    const message = typeof payload === 'string' ? payload : payload?.error || payload?.message || `Request failed with ${response.status}`
    throw new Error(message)
  }

  return payload as T
}
